import { clearObservedUser, getFaroSessionId } from '@/observability/faro'
import { redirectToLogin } from '@/router/utils/loginRedirect'

/**
 * Request hook shared by the API clients: an expired session goes back to
 * the login page, a live one sends its bearer token. Every request also
 * carries the Faro session id, so a backend trace joins the browser session
 * (see RecordFaroSession in the API).
 */
export function authorizeRequest(config: {
  headers: Record<string, string>
}): void {
  const token = localStorage.getItem('token')
  const expiration = localStorage.getItem('expiration')

  if (token && expiration && new Date() > new Date(expiration)) {
    localStorage.removeItem('token')
    localStorage.removeItem('expiration')
    clearObservedUser()
    redirectToLogin()
  }

  if (localStorage.getItem('token')) {
    config.headers.Authorization = 'Bearer ' + localStorage.getItem('token')
  }

  const faroSessionId = getFaroSessionId()
  if (faroSessionId) {
    config.headers['x-faro-session-id'] = faroSessionId
  }
}
